import App from './App'
import router from './router/router'
//工具类
import KZ from './assets/js/utils'


import pca from '../static/data/pca'
import dsBridge from '../static/js/dsbridge.js'
import KZ_CONFIG from './config'
import './assets/js/axios.conf'
import './assets/css/common.scss'

import Vue from 'vue'
import Vuex from 'vuex'
import store from './vuex/store'


if (window.KZ_CONFIG.NODE_ENV === 'development'){
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
  console.info('development mode');
}

Vue.use(Vuex);

window.dsBridge = dsBridge;
window.SSQ = pca;

router.beforeEach( function(to, from, next) {
  var isApp = KZ.CallNativeNotify('checkCourseInfo', to.meta);
  if (isApp) {
    isApp = '1';
  } else {
    isApp = '0';
  }
  sessionStorage.setItem("isApp", isApp);

  var date = new Date();
  var year = date.getFullYear();
  var mouth = date.getMonth() < 10 ? '0'+date.getMonth():date.getMonth();
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var minut = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  var time = year + mouth + day + hour + minut + second;
  to.query.time = time;
  if (to.matched.some(function(record){
    return record.meta.requiresAuth;
  })) {
    //这里判断用户是否登录，验证本地存储是否有token
    var user_id = KZ.GetUserId();
    if (!user_id) { // 判断当前的token是否存在
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next();
    }
  } else {
    next() // 确保一定要调用 next()
  }
})

/* eslint-disable no-new */
Vue.component('MyRequest', MyRequest)
Vue.use(MyRequest);
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App,
    MyRequest
  },
  template: '<App/>'
});
Vue.config.errorHandler = function(err, vm, info) {
  var componentName = formatComponentName(vm);
  var propsData = vm.$options && vm.$options.propsData;
  fundebug.notifyError(err, {
    metaData: {
      componentName: componentName,
      propsData: propsData,
      info: info
    }
  });
};

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';

  var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');

}
//移动端登陆 h5保存移动端的登陆信息
dsBridge.register('loginSuccessNotify', function(data, callback) {
  localStorage.setItem("user_info", JSON.stringify(data));
});
dsBridge.register('registerDeviceSystemInfo', function(data, callback) {
  if (data.source) {
    localStorage.setItem('source', data.source);
  }
  if (data.version) {
    localStorage.setItem('version', data.version);
  }
});
//移动端通知h5退出登陆
dsBridge.register('logoutNotify', function(data, callback) {
  localStorage.removeItem('user_info');
});

(function() {
  if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);  }
  }
  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function() {
      WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
    });
  }
})();



// WEBPACK FOOTER //
// ./src/index.js